import axios from '@/utils/axios';

// 登录
export function Login(memberInfo, password, unionid, openid) {
    return axios({
        url: '/account/login',
        method: 'post',
        params: {memberInfo, password, unionid, openid},
    });
}

// 快速登录
export function QuickLogin(unionId, openId) {
    return axios({
        url: '/account/quick/login',
        method: 'post',
        params: {unionId, openId},
    });
}

// 手机号登录
export function LoginByTelephone(telephone, password,unionId, openId) {
    return axios({
        url: '/account/loginByTelephone',
        method: 'post',
        params: {telephone, password, unionId, openId},
    });
}

// 登出
export function Logout() {
    return axios({
        url: '/account/logout',
        method: 'post',
        params: {},
    });
}

// 忘记密码
export function ForgetPassword() {
    return axios({
        url: '/account/menu/list',
        method: 'get',
        params: {},
    });
}

//注册
export function Register(mobile, password, confirmPassword, realname, type, captcha) {
    return axios({
        url: '/account/registry',
        method: 'post',
        params: {mobile, password, confirmPassword, realname, type, captcha},
    });
}

// 登陆记录
export function LoginLog(page, limit) {
    return axios({
        url: '/account/login-log/list',
        method: 'get',
        params: {page, limit},
    });
}

//密码重置-会员查询
export function SearchMember(memberInfo) {
    return axios({
        url: '/account/member/search',
        method: 'get',
        params: {memberInfo},
    });
}

//密码重置-查询会员最新已配送订单信息
export function SearchOrder(memberId) {
    return axios({
        url: '/account/order/search',
        method: 'get',
        params: {memberId},
    });
}

//密码重置-发送验证码
export function SendCaptcha(mobile) {
    return axios({
        url: '/account/captcha/send',
        method: 'post',
        params: {mobile},
    });
}

//密码重置-验证短信验证码
export function CheckCaptcha(memberId, mobile, captcha) {
    return axios({
        url: '/account/captcha/check',
        method: 'post',
        params: {memberId, mobile, captcha},
    });
}

//密码重置
export function ResetPassword(password, confirmPassword) {
    return axios({
        url: '/account/password/reset',
        method: 'post',
        params: {password, confirmPassword},
    });
}


//用户微信授权
export function WeChatUserInfo(code) {
    return axios({
        url: '/wechat/userInfo',
        method: 'post',
        params: {code},
    });
}

//用户端系统维护查询
export function SystemStatus() {
    return axios({
        url: '/sysOpt/maintenance/status',
        method: 'get',
        params: {},
    });
}

//用户端系统维护内容详情
export function SystemContent() {
    return axios({
        url: '/sysOpt/maintenance/content',
        method: 'get',
        params: {},
    });
}

//获取微信授权用户信息
export function WeChatInfo(url) {
    return axios({
        url: '/wechat/sign',
        method: 'get',
        params: {url},
    });
}

//获取微信授权用户信息
export function GetTelephone(telephone) {
    return axios({
        url: '/account/get/telephone',
        method: 'get',
        params: {telephone},
    });
}

//获取微信unionId
export function WeChatUnion(appId, secret, openId) {
    return axios({
        url: '/wechat/union',
        method: 'post',
        params: {appId, secret, openId},
    });
}